import { render, staticRenderFns } from "./SocialReviewsStats.vue?vue&type=template&id=5aea189a&"
import script from "./SocialReviewsStats.vue?vue&type=script&lang=js&"
export * from "./SocialReviewsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports